$(document).ready(function () {
    let lazyImages = $(".lazy-load");
    function isInViewport(element) {
        const rect = element.getBoundingClientRect();
        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <=
            (window.innerHeight || document.documentElement.clientHeight) &&
            rect.right <=
            (window.innerWidth || document.documentElement.clientWidth)
        );
    }

    // Function to lazy load images
    function lazyLoadImages() {
        lazyImages.each(function () {
            const img = $(this);
            if (isInViewport(this)) {
                img.attr("src", img.data("src"));

                // Remove the shimmer effect once the image is loaded
                img.on("load", function () {
                    img.parent().removeClass("lazy-load-wrapper");
                    img.removeClass("lazy-load");
                });
            }
        });
    }

    // Initial check on page load
    setTimeout(() => {
        lazyLoadImages();
    }, 1000);

    // Check on scroll and resize
    $(window).on("scroll resize", function () {
        lazyLoadImages();
    });

    $(".globalDigitalHealthSection,.startupStories,.industryVoice,.spotlight").on("scroll", function () {
        lazyLoadImages();
    });
});
